import { Match } from '../../../../../api-types';
import { TriggerProps } from '@ligr/themes/lib/football/themes/default/Player/types';
import React from 'react';
import { Select } from '../../../../Select';
import './style.scss';

interface PlayercardCustomProps {
  value?: TriggerProps;
  onChange: (update: TriggerProps) => any;
  match: Match;
  disabled?: boolean;
}

export const Player: React.FunctionComponent<PlayercardCustomProps> = ({ disabled, onChange, value = {}, match }) => {
  return (
    <div className="playercard">
      <Select
        disabled={disabled}
        value={value.playerId}
        onChange={event => {
          // @ts-ignore
          onChange({ playerId: event.target.value ? parseInt(event.target.value) : null });
        }}
        label="Player"
        options={([
          {
            value: null,
            label: 'Select Player'
          }
        ] as { value: null | number; label: string }[]).concat(
          match?.lineup
            ?.sort((a, b) => {
              if (a.team.id !== b.team.id) return b.team.id - a.team.id;
              return parseInt(a.number!) - parseInt(b.number!);
            })
            .map(({ player, number, position, team }) => ({
              label: `${number} - ${team.abbreviation} - ${player.firstName} ${player.lastName} (${position})`,
              value: player.id
            })) || []
        )}
      />
    </div>
  );
};
